import {LeaveTypeColumnConfig, LeaveTypeBalanceQualifier} from "./LeaveReportConfig";

export default class LeavesReportUtils {
    static reportParamsWithLeaves(reportParams) {
        return reportParams.columnsConfig !== LeaveTypeColumnConfig.BALANCES_ONLY;
    }

    static reportParamsWithPTO(reportParams) {
        return reportParams.columnsConfig !== LeaveTypeColumnConfig.LEAVE_TIME_ONLY &&
               reportParams.balanceQualifier !== LeaveTypeBalanceQualifier.SICK_DAYS_ONLY;
    }

    static reportParamsWithSick(reportParams) {
        return reportParams.columnsConfig !== LeaveTypeColumnConfig.LEAVE_TIME_ONLY &&
               reportParams.balanceQualifier !== LeaveTypeBalanceQualifier.PTO_ONLY;
    }
};


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/LeavesReportUtils.js